import { unit } from '../../models/response/y-te/unit';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_UNIT_PATH = 'unit';

class UnitApi extends BaseCRUDApi<unit> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
}
export const unitApi = new UnitApi(API_UNIT_PATH);
